import { render, staticRenderFns } from "./ScoreList.vue?vue&type=template&id=2d0ff667&"
import script from "./ScoreList.vue?vue&type=script&lang=js&"
export * from "./ScoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports